import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { LocaleService } from '../shared/services/locale.service';
import { ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-platform-updates',
	templateUrl: './platform-updates.component.html',
	styleUrls: ['./platform-updates.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PlatformUpdatesComponent implements OnInit {
	data: object;
	platform: string;
	embedded: boolean = false;
	Result: any = [];
	nextPage: any;
	page: any = 0;
	platformTitle: string;
	loading: boolean = false;
	visible: boolean = false;
	notEmptyPost = true;
	showLoad: boolean = false;
	load: boolean = false;
	description: any;
	versionList: any = [];
	constructor(public locale: LocaleService, private route: ActivatedRoute, private api: ApiService) {}

	ngOnInit(): void {
		// const formData: FormData = new FormData();
		// formData.append('lang', this.locale.lang);
		// formData.append('platform', '1');
		// this.api.getVersionHistory().subscribe((res)=>{
		//     this.data=res['response']
		// })
		this.route.queryParams.subscribe((queries: Params) => {
			this.platform = queries['platform'];
			this.embedded = queries['embedded'];
		});
		this.updates(this.platform);
	}
	updates(id) {
		this.page++;
		this.platform = id;
		const data = {
			lang: this.locale.lang,
			platform: this.platform,
		};

		this.loading = true;

		this.api.getVersionHistory(data).subscribe((res) => {
			this.loading = false;
			if (this.platform === '1') {
				this.platformTitle = 'iOS';
			} else if (this.platform === '2') {
				this.platformTitle = 'ANDROID';
			} else {
				this.platformTitle = 'WEB';
			}

			this.nextPage = res['response']['pages'];

			if (this.page >= this.nextPage) {
				this.load = false;
			} else {
				this.load = true;
			}

			this.Result = res['response']['data'];
			this.showLoad = false;
		});
	}
	LoadMore() {
		this.showLoad = true;
		this.page++;

		if (this.page <= this.nextPage) {
			this.updates(this.platform);
		}
	}
}
